import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import Image from '../Base/Image';
import css from '@src/styles/components/aggregation/offer.scss';
import Rating from '../Base/Rating';
import Tooltip from '../Base/Tooltip';
import Scoring from './Scoring';
import Translation from '../Base/Translation';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class Offer extends React.Component {

    constructor(props) {

        super(props);

        // eslint-disable-next-line no-new
        new AdaptiveTrait(this);
    }

    static get propTypes() {

        return {
            isBest: PropTypes.bool,

            anchor: PropTypes.string,
            companyAnchor: PropTypes.string,
            companyLink: PropTypes.string,
            imageUri: PropTypes.string,

            rating: PropTypes.number,
            ratingCount: PropTypes.number,
            ratingLabel: PropTypes.string,
            ratingLabelLink: PropTypes.string,

            scoreLabel: PropTypes.string,
            scoreLink: PropTypes.string,
            scoreValue: PropTypes.number,

            sum: PropTypes.string,
            rate: PropTypes.string,
            term: PropTypes.string,

            link: PropTypes.string,
        };
    }

    renderMobile() {

        const tag = this.props.isBest
            ? <div className={ css.offerTag }><i className={ style('icon-star-outline') }></i>{ this.getTagLabel() }</div>
            : null;

        return (
            <div className={ css.offer + (this.props.isBest ? ` ${css.offerHasTag}` : '') }>

                {/* optional card tag */}
                { tag }

                {/* bank logo or card image */}
                <div className={ style('flex items-center justify-between') }>
                    { this.getHtmlImage() }
                    <i className={ style('icon-compare text-muted title2') }></i>
                </div>

                {/* company name */}
                { this.getHtmlCompany() }

                {/* offer name */}
                { this.getHtmlName() }

                {/* rating */}
                { this.getHtmlRating() }

                {/* scoring */}
                <Scoring
                    className={ style('mt-4') }
                    checkScoreLink={ this.props.scoreLink }
                    value={ this.props.scoreValue } />

                { this.getHtmlDetails('title3') }

                { this.getHtmlButton() }

            </div>
        );
    }

    renderDesktop() {

        const tag = this.props.isBest
                ? <div className={ css.offerTag }><i className={ style('icon-star-outline') }></i>{ this.getTagLabel() }</div>
                : null,

            classList = [
                css.offer,
                css.offerExtended,
                this.props.isBest ? ` ${css.offerHasTag}` : null,
            ];

        return (
            <div className={ classList.join(' ') }>

                {/* optional card tag */}
                { tag }

                <div className={ style('flex gap-lg') }>

                    <div className={ style('flex-center flex-wrap size-x-210 mt-2') }>
                        { this.getHtmlImage() }
                        { this.getHtmlButton() }
                    </div>

                    <div className={ style('flex-1') }>

                        {/* company name */}
                        { this.getHtmlCompany() }

                        {/* offer name */}
                        { this.getHtmlName() }

                        {/* rating */}
                        { this.getHtmlRatingDesktop() }

                        <div className={ style('flex items-center gap-2xl mt-2 tablet:gap-0 tablet:flex-wrap') }>
                            { this.getHtmlDetails('title2 tablet:w-full') }
                        </div>

                    </div>

                    <div className={ style('size-x-210 flex flex-wrap items-start justify-end tablet:hidden') }>
                        <i className={ style('icon-compare text-muted title2') }></i>

                        {/* scoring */}
                        <Scoring
                            className={ style('mt-6') }
                            checkScoreLink={ this.props.scoreLink }
                            value={ this.props.scoreValue } />
                    </div>

                </div>

            </div>
        );
    }

    getHtmlImage() {

        if (!this.hasImage())
            return <span></span>;
            // span required by fix right block position

        return <a href={ this.props.companyLink }>
            <Image className={ css.offerImage } alt={ this.props.anchor } src={ this.props.imageUri } />
        </a>;
    }

    getHtmlName() {

        return <a className={ style('title3 mt-2 block text-black') } target='_blank' href={ this.props.link }>
            { this.props.anchor }
        </a>;
    }

    getHtmlCompany() {

        return <a className={ style('text-small text-muted mobile:mt-4 block') } href={ this.props.companyLink }>
            { this.props.companyAnchor }
        </a>;
    }

    getHtmlRatingDesktop() {

        if (!this.props.rating)
            return null;

        return (
            <>
                <div className={ style('flex items-center mt-3') }>
                    <Translation className={ style('text-medium text-muted') } tag='aggregation.rating.label' />
                    <Tooltip><Translation tag='aggregation.rating.desc' /></Tooltip>
                </div>
                { this.getHtmlRating() }
            </>
        );

    }

    getHtmlRating() {

        return <Rating
            className={ style('mt-2') }
            value={ this.props.rating }
            label={ this.props.ratingLabel }
            count={ this.props.ratingCount }
            link={ this.props.ratingLabelLink } />;
    }

    getHtmlDetails(titleClass) {

        const htmlSum = this.props.sum
            ? <div className={ style(`${titleClass} text-medium whitespace-nowrap mt-4`) }>{ this.props.sum }</div>
            : null;

        return (
            <>
                {/* sum */}
                { htmlSum }

                <div className={ style('grid-2 mt-4 gap-2xl') }>

                    {/* rate */}
                    { this.getHtmlFieldBlock('product.rate.title', 'aggregation.product.rate.desc', this.props.rate) }

                    {/* term */}
                    { this.getHtmlFieldBlock('product.term.title', 'aggregation.product.term.desc', this.props.term) }

                </div>
            </>
        );

    }

    getHtmlButton() {

        return (
            <a className={ style('button w-full mt-6') } target='_blank' href={ this.props.link }>
                <Translation tag='aggregation.offer.title' />
            </a>
        );
    }

    getHtmlFieldBlock(title, description, value) {

        if (value == undefined || !value.trim())
            return null;

        return (
            <div className={ style('flex flex-wrap gap-md') }>
                <div className={ style('flex items-center w-full') }>
                    <Translation className={ style('text-muted') } tag={ title } />
                    <Tooltip><Translation tag={ description } /></Tooltip>
                </div>
                <div className={ style('whitespace-nowrap text-medium') }>{ value }</div>
            </div>
        );

    }

    hasImage() {

        return !!this.props.imageUri;
    }

    getTagLabel() {

        return <Translation tag='aggregation.product.best' />;
    }

}